/* eslint-disable react/prop-types */
import { ArrowRight, Lightbulb } from "@phosphor-icons/react";

/**
 * Phase 7 — "Next Step" advisory hint. Pure client-side, role-aware.
 * Reads existing doc state. No API calls.
 */
function pickHint(doc, role) {
  if (!doc) return null;
  const dt = doc.doc_type;
  const st = doc.status || "";
  const ap = doc.approval_status || "";

  // Quotation / Estimation
  if (dt === "estimation") {
    if (ap === "draft") return { label: "Submit for approval", tone: "indigo" };
    if (ap === "pending_bdm") return { label: "Awaiting BDM approval", tone: "amber" };
    if (ap === "pending_manager") return { label: "Awaiting Manager approval", tone: "amber" };
    if (ap === "rejected") return { label: "Rejected — revise and resubmit", tone: "rose" };
    if (ap === "approved" && !doc.linked_proforma_number && !doc.linked_invoice_number && !doc.linked_so_id) {
      return { label: "Convert to Proforma", tone: "emerald" };
    }
    if (st === "converted_to_sales_order") return { label: "Sales Order created — track fulfilment", tone: "slate" };
    return null;
  }

  // Proforma
  if (dt === "proforma") {
    if (!doc.linked_invoice_number) return { label: "Create Invoice", tone: "emerald" };
    return { label: "Invoice already created", tone: "slate" };
  }

  // Invoice
  if (dt === "invoice") {
    const total = Number(doc.total || 0);
    const paid  = Number(doc.amount_paid || 0);
    if (st === "paid") return { label: "Fully paid — close the loop", tone: "emerald" };
    if (st === "partial") return {
      label: `Record Payment (₹${(total - paid).toLocaleString("en-IN")} remaining)`,
      tone: role === "cfo" || role === "admin" ? "indigo" : "slate",
    };
    if (st === "unpaid") return {
      label: "Record Payment",
      tone: role === "cfo" || role === "admin" ? "indigo" : "slate",
    };
  }

  return null;
}

const TONE = {
  indigo:  "bg-indigo-50 border-indigo-200 text-indigo-800",
  emerald: "bg-emerald-50 border-emerald-200 text-emerald-800",
  amber:   "bg-amber-50 border-amber-200 text-amber-800",
  rose:    "bg-rose-50 border-rose-200 text-rose-800",
  slate:   "bg-slate-50 border-slate-200 text-slate-700",
};

export default function BillingNextStepHint({ doc, role }) {
  const hint = pickHint(doc, role);
  if (!hint) return null;
  return (
    <div
      className={`rounded-lg border px-4 py-2.5 flex items-center gap-2.5 text-sm font-medium print:hidden ${TONE[hint.tone] || TONE.slate}`}
      data-testid="billing-next-step-hint"
    >
      <Lightbulb size={16} weight="fill" className="shrink-0" />
      <span className="flex-1">Recommended next step:</span>
      <span className="font-bold flex items-center gap-1">
        {hint.label}
        <ArrowRight size={14} weight="bold" />
      </span>
    </div>
  );
}
